// Shared per-website visitor auth runtime (site_users API).
// Canonical token key: site_token_{websiteId}

export default `
function snagcartSiteTokenKey() {
  return 'site_token_' + (window.WEBSITE_ID || window.DASH_WEBSITE_ID || '');
}

function snagcartMigrateLegacySiteToken() {
  var key = snagcartSiteTokenKey();
  if (!key || key === 'site_token_') return;
  try {
    var id = window.WEBSITE_ID || window.DASH_WEBSITE_ID || '';
    var legacy = localStorage.getItem('snagcart_site_token_' + id);
    if (legacy && !localStorage.getItem(key)) {
      localStorage.setItem(key, legacy);
    }
  } catch (e) {}
}

function snagcartGetSiteToken() {
  snagcartMigrateLegacySiteToken();
  try {
    return localStorage.getItem(snagcartSiteTokenKey()) || '';
  } catch (e) {
    return '';
  }
}

function snagcartSetSiteToken(token) {
  if (!token) return;
  try {
    localStorage.setItem(snagcartSiteTokenKey(), token);
    var id = window.WEBSITE_ID || window.DASH_WEBSITE_ID || '';
    if (id) localStorage.removeItem('snagcart_site_token_' + id);
  } catch (e) {}
}

function snagcartClearSiteToken() {
  try {
    var id = window.WEBSITE_ID || window.DASH_WEBSITE_ID || '';
    localStorage.removeItem(snagcartSiteTokenKey());
    if (id) localStorage.removeItem('snagcart_site_token_' + id);
  } catch (e) {}
}

function snagcartAuthApiRoot() {
  var base = String(window.API_URL || window.DASH_BACKEND || '').replace(/\\/$/, '');
  if (!base) return '/api/sites/';
  if (base.indexOf('/api') === -1) return base + '/api/sites/';
  return base + '/sites/';
}

function snagcartSetupAuthToggle() {
  document.querySelectorAll('[data-auth-toggle]').forEach(function(button) {
    if (button.dataset.snagcartAuthToggleBound === 'true') return;
    button.dataset.snagcartAuthToggleBound = 'true';
    button.addEventListener('click', function() {
      var mode = this.getAttribute('data-auth-toggle');
      var authSection = this.closest('section');
      if (!authSection) return;
      authSection.querySelectorAll('[data-auth-toggle]').forEach(function(btn) {
        var active = btn.getAttribute('data-auth-toggle') === mode;
        btn.style.background = active ? 'white' : 'transparent';
        btn.style.color = active ? '#0f172a' : '#e5e7eb';
        btn.style.fontWeight = active ? '600' : '500';
      });
      authSection.querySelectorAll('[data-site-auth-form]').forEach(function(form) {
        form.style.display = form.getAttribute('data-site-auth-form') === mode ? 'block' : 'none';
      });
    });
  });
}

function snagcartSetupAuthForms() {
  var websiteId = window.WEBSITE_ID || window.DASH_WEBSITE_ID || '';
  if (!websiteId) return;

  document.querySelectorAll('[data-site-auth-form]').forEach(function(form) {
    if (form.dataset.snagcartAuthFormBound === 'true') return;
    form.dataset.snagcartAuthFormBound = 'true';

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var mode = form.getAttribute('data-site-auth-form');
      var section = form.closest('section');
      var messageEl = section ? section.querySelector('[data-site-auth-message]') : null;
      if (messageEl) messageEl.textContent = '';

      var payload = {
        email: (form.email && form.email.value) || '',
        password: (form.password && form.password.value) || '',
      };
      if (mode === 'signup') {
        payload.name = (form.name && form.name.value) || '';
      }

      var endpoint = snagcartAuthApiRoot() + websiteId + '/auth/' + (mode === 'signup' ? 'register' : 'login');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function(res) { return res.json().catch(function() { return {}; }).then(function(body) { return { ok: res.ok, body: body }; }); })
        .then(function(result) {
          if (result.body && result.body.token) {
            snagcartSetSiteToken(result.body.token);
            if (messageEl) {
              messageEl.style.color = '#22c55e';
              messageEl.textContent = 'Signed ' + (mode === 'signup' ? 'up' : 'in') + ' successfully. Redirecting…';
            }
            var redirect = form.getAttribute('data-auth-redirect') || '?page=my-account';
            setTimeout(function() {
              if (redirect.indexOf('http') === 0) window.location.href = redirect;
              else window.location.href = redirect;
            }, 600);
            return;
          }
          var detail = (result.body && (result.body.detail || result.body.message)) || 'Authentication failed';
          if (messageEl) {
            messageEl.style.color = '#f97316';
            messageEl.textContent = typeof detail === 'string' ? detail : 'Authentication failed';
          }
        })
        .catch(function() {
          if (messageEl) {
            messageEl.style.color = '#f97316';
            messageEl.textContent = 'Authentication error. Please try again.';
          }
        });
    });
  });
}

function snagcartInitSiteAuth() {
  snagcartMigrateLegacySiteToken();
  snagcartSetupAuthToggle();
  snagcartSetupAuthForms();
  if (typeof window !== 'undefined') {
    window.snagcartGetSiteToken = snagcartGetSiteToken;
    window.snagcartSetSiteToken = snagcartSetSiteToken;
    window.snagcartClearSiteToken = snagcartClearSiteToken;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', snagcartInitSiteAuth);
} else {
  snagcartInitSiteAuth();
}

var snagcartAuthObserver = new MutationObserver(function() {
  snagcartSetupAuthToggle();
  snagcartSetupAuthForms();
});
if (document.body) {
  snagcartAuthObserver.observe(document.body, { childList: true, subtree: true });
}
`;
